export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game.vue?vue&type=template&id=53084f0e"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game.vue?vue&type=template&id=53084f0e
// module id = Tzui
// module chunks = 0